// TODO -- Move to checkout-utils
export let ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["Json"] = "application/json";
  return ContentType;
}({});
//# sourceMappingURL=ContentType.js.map